import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import kidixLogo from "../../../../assets/logo--with-kidix-no-background.png";
import kidixMark from "../../../../assets/logo--without-kidix-no-background.png";

export function Logo({ light = false, compact = false }: { light?: boolean; compact?: boolean }) {
  const { isArabic } = useLanguage();
  return <Link to="/" className={`brand ${light ? "brand--light" : ""}`} aria-label={isArabic ? "الرئيسية · كيديكس" : "Kidix home"}>
    <img src={compact ? kidixMark : kidixLogo} alt="Kidix" width={compact ? 517 : 616} height={compact ? 482 : 442} />
  </Link>;
}
